module.exports = __webpack_public_path__ + "static/media/front.db2251ae.png";